    (function($) {

        var wow = new WOW(
      {
       
    }
    )
    wow.init();



	$(window).on('scroll',function(){
		var scrollTop = $(this).scrollTop();

		if(scrollTop >= 150  && !$('header.header>.header-inner').hasClass('scrolled-header')) {
			$('header.header>.header-inner').addClass('scrolled-header');
            $('img.main-logo.custom-logo').fadeOut(500,function(){
                $('img.scroll-logo.custom-logo').fadeIn(200);
            });
		}

		else if(scrollTop <= 149 && $('header.header>.header-inner').hasClass('scrolled-header')) {
			$('header.header>.header-inner').removeClass('scrolled-header');
            $('img.scroll-logo.custom-logo').fadeOut(500,function(){
                $('img.main-logo.custom-logo').fadeIn(200);
            });
		}
	});

// Function to equalize heights for all slides in a slider
function setSliderSlideHeights($slider) {
  var maxHeight = 0;
  $slider.find('.slick-slide').css('height', 'auto'); // Reset heights
  $slider.find('.slick-slide').each(function(){
    var thisHeight = $(this).outerHeight();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });
  $slider.find('.slick-slide').css('height', maxHeight + 'px');
}

// Generic function to initialize a slider with shared options and height logic
function initCustomSlider(selector, options) {
  var $slider = $(selector);

  $slider.on('init', function(event, slick){
    setSliderSlideHeights($slider);
  });

  $slider.on('setPosition', function(event, slick){
    setSliderSlideHeights($slider);
  });

  $(window).on('resize', function(){
    setSliderSlideHeights($slider);
  });

  $slider.slick(options);
}

$(document).ready(function(){

    initCustomSlider('.case-studies-slider', {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.case-studies-arrows .arrow-btn.prev'),
      nextArrow: $('.case-studies-arrows .arrow-btn.next'),
      appendArrows: $('.case-studies-arrows'),
      dots: true,
      appendDots: $('.case-studies-dots'),
      infinite: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    });

    initCustomSlider('.innovation-centres-slider', {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.innovation-arrows .arrow-btn.prev'),
      nextArrow: $('.innovation-arrows .arrow-btn.next'),
      appendArrows: $('.innovation-arrows'),
      dots: true,
      appendDots: $('.innovation-dots'),
      infinite: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    });

  var $slider = $('.testimonials-slider');
  var singleSlide = $slider.hasClass('single-slide');

  initCustomSlider('.testimonials-slider', {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !singleSlide,
    prevArrow: $('.test-arrows .arrow-btn.prev'),
    nextArrow: $('.test-arrows .arrow-btn.next'),
    appendArrows: $('.test-arrows'),
    dots: !singleSlide,
    appendDots: $('.test-dots'),
    infinite: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });

  // Optionally, ensure arrows/dots containers are hidden if only one slide
  if(singleSlide) {
    $('.test-arrows').hide();
    $('.test-dots').hide();
  }





		  $('.projects-preview-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 1,
		    autoplay: true,
		    //appendArrows: $('.projects-preview-arrows'),
		    fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
		  });

		   $('.partner-logos-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 3,
		    autoplay: true,
            autoplaySpeed: 0,
            speed: 2000,
		    dots: false,
		   responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 2,
		        centerMode: true,
		      }
		    },

             {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              }
            },
		    ],
		  });

        $('.posts-slider').slick({
            infinite: false,
            arrows: true,
            slidesToShow: 4,
            autoplay: true,
            dots: true,
            appendArrows: $('#posts-arrow-container'),
           responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
         var contents_slider = function($selector, $slides) {

        var slider = $($selector).find('.contents-slider'),
            slider_prev = $($selector).find('.content-prev'),
            slider_next = $($selector).find('.content-next');

         $(slider).slick({
            infinite: false,
            arrows: true,
            slidesToShow: $slides,
            autoplay: true,
            dots: false,
            prevArrow: slider_prev,
            nextArrow: slider_next,
           responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: $slides,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
        }

        $('.contents-slider-outer').each(function(){
            contents_slider(this, 2);
        });

        contents_slider('.testimonials-section',1);
        contents_slider('.contents-slider-outer-letters',3);

            //This option is for pages with a slider of images
    var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
    var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });
    

    var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

        var lightboxGall = new SimpleLightbox('.image-gallery-extra>.single-image>a', { /* options */ });

        var gallerySlider = function($selector) { 

        //var galleryDots = $($selector).siblings('.gallery-dots');
        var galleryArrows = $($selector).siblings('.slider-arrows'),
            nextArrow = galleryArrows.find('.next'),
            prevArrow = galleryArrows.find('.prev');
            
        $($selector).slick({
          arrows: true,
          infinite: true,
          dots: false,
          speed: 300,
          slidesToShow: 3,
          autoplay:true,
          initialSlide: 0,
          centerMode: true,
          centerPadding: centerPadAmount + 'px',
          appendArrows: galleryArrows,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          //asNavFor: '.image-gallery',
          fade: false,
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
              }
            }
            ],
        });
        }

        //gallerySlider('.image-gallery-header-slider');

        var imageGalleryExtra = $('.image-gallery-extra');

        $(imageGalleryExtra).each(function(){
            gallerySlider(this);
        });

        //This will create a lightbox gallery to replace the default wordpress gallery
         var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

          galleryItems.each(function() {
          
          var   caption = $(this).find( "figcaption" ),
                captionText = $(caption).text(),
                link = $(this).find( "a" ),
                image = $(this).find( "img" );
          $(image).attr('title', captionText);


          });
           // Galleries on Project Pages

           if($('figure.wp-block-gallery').length > 0) {
              var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
                // captionSelector : 'figcaption',
                // captionType : 'text'
              });
            }

            var lightboxTiles = new SimpleLightbox('.image-gallery-tiles>.cell>.single-image>a', {
                // captionSelector : 'figcaption',
                // captionType : 'text'
              });
	});

//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});


    $(window).on('load',function() {        
        // Animate loader off screen
        $("#loader").fadeOut(200);
    });

//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
});

    var resizeItem = function($selector) {
        var itemSize = 0;

        $($selector).each(function(i){
                if($(this).innerHeight() > itemSize) {
                    itemSize = $(this).innerHeight();
                }
        })

        $($selector).css('height',itemSize + 'px');
           
        };

    $(window).on('load',function(){
        //resizeItem('.page-link-contents');
        resizeItem('.post-type-archive-case-study h3.slider-title');
    });

    $('#tm-filters button').on('click',function(event){
        var dataTarget = $(this).data('tm-target');

         $('#tm-filters button').removeClass('active-filter');
         $(this).addClass('active-filter');

        $('.tm-with-filters').hide();
            $(dataTarget).each(function(){
                $(this).fadeIn(300);
            })
        });

       
            var timelineItems =  $('.timeline-outer .timeline-inner .timeline-item'),
                timelineOffset = 0,
                timelineSingle = 0;


            $(window).on('load resize', function(e){
                    timelineOffset = 0;
                    timelineSingle = 0;
                    $(timelineItems).each(function(i){
                    timelineSingle = $(this).innerWidth();
                    timelineOffset = timelineOffset + timelineSingle;
                    $(this).data('timeline-offset',timelineOffset);
                });
            });
        

        var updateTimeline = function($input) {
            if($input.length > 0) {
            var thisOffset = ($($input).data('timeline-offset') - ($('.timeline-outer').innerWidth() - timelineSingle) / 2) - timelineSingle,
                vpWidth = $(window).width() / 2,
                offset = vpWidth - thisOffset,
                setYear = $($input).data('tl-year'),
                setData = $($input).data('tl-info');

            $('.timeline-inner').animate( { scrollLeft: thisOffset }, 1000);
            $(timelineItems).removeClass('active-year');
            $($input).addClass('active-year');

            var tlscroll = $('.timeline-inner').scrollLeft();

            $('.timeline-info').fadeOut(300,function(){
                console.log(tlscroll);
                $('.tl-year').html(setYear);
                $('.tl-info').html(setData);
                $('.timeline-info').fadeIn(300);

            });
            }
        }

        $(timelineItems).on('click',function(){
            updateTimeline($(this));
        });

        $('.tl-previous').on('click',function(){
            var previousTL = $('.timeline-item.active-year').prev();
            updateTimeline(previousTL);
        });

        $('.tl-next').on('click',function(){
            var nextTL = $('.timeline-item.active-year').next();
            updateTimeline(nextTL);
        });

        $(document).foundation();

        $(document).on('hide.zf.dropdown', function(e) {
          const $pane = $(e.target);
          $pane.one('transitionend', () => $pane.css('display', 'none'));
          $pane.css('display', 'block'); // keep visible while animating
        });

        $(window).on('load resize', function(){
            var headerInner = $('.header-inner').innerHeight();

            $('.content').css('padding-top', headerInner + 'px'); 
        });

document.addEventListener("DOMContentLoaded", function () {
  const offerings = document.querySelectorAll(".single-offering");
  const contentOuter = document.querySelector(".offering-content-outer");
  const allContent = document.querySelectorAll(
    ".offering-content-outer .offering-inner-content, .single-offering + .offering-inner-content"
  );

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function setupLayout() {
    if (isMobile()) {
      // move each content block under its single-offering
      offerings.forEach(offering => {
        const targetSelector = offering.getAttribute("data-tab-target");
        const target = document.querySelector(targetSelector);
        if (target && target.parentNode !== offering.parentNode) {
          offering.insertAdjacentElement("afterend", target);
        }
      });
    } else {
      // move all content blocks back into contentOuter
      allContent.forEach(c => {
        if (c.parentNode !== contentOuter) {
          contentOuter.appendChild(c);
        }
      });
    }
  }

  // run once on load
  setupLayout();

  // re-run on resize
  window.addEventListener("resize", setupLayout);

  offerings.forEach(offering => {
    offering.addEventListener("click", function () {
      const targetSelector = this.getAttribute("data-tab-target");
      const target = document.querySelector(targetSelector);
      if (!target) return;

      if (isMobile()) {
        // accordion behaviour
        const isActive = this.classList.contains("active-offering");
        offerings.forEach(o => o.classList.remove("active-offering"));
        allContent.forEach(c => c.classList.remove("active-offering-content"));

        if (!isActive) {
          this.classList.add("active-offering");
          target.classList.add("active-offering-content");
        }
      } else {
        // desktop tab behaviour
        offerings.forEach(o => o.classList.remove("active-offering"));
        this.classList.add("active-offering");

        allContent.forEach(c =>
          c.classList.remove("active-offering-content")
        );
        target.classList.add("active-offering-content");
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Get all play buttons
  const playButtons = document.querySelectorAll('.play-btn');

  playButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const popupSelector = btn.getAttribute('data-popup');
      const videoUrl = btn.getAttribute('data-video');
      const popup = document.querySelector(popupSelector);
      const iframe = popup.querySelector('.youtubeFrame');
      // Set the src to the video URL
      iframe.src = videoUrl;
      popup.style.display = 'flex';
    });
  });

  // Get all popups and their close buttons
  const popups = document.querySelectorAll('.video-popup');
  popups.forEach(function(popup) {
    const closeBtn = popup.querySelector('.closePopup');
    const iframe = popup.querySelector('.youtubeFrame');
    // Hide popup on close button click
    closeBtn.addEventListener('click', function() {
      popup.style.display = 'none';
      iframe.src = ""; // Stop video
    });
    // Optional: Hide popup when clicking outside the video box
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        iframe.src = ""; // Stop video
      }
    });
  });
});


})( jQuery );


document.addEventListener('DOMContentLoaded', function () {
    const searchIcon = document.querySelector('.search-icon');
    const searchOverlay = document.getElementById('search-overlay');
    const closeOverlay = document.getElementById('close-overlay');
    
    // Function to fade in the overlay
    function showOverlay() {
        searchOverlay.classList.add('visible');
    }

    // Function to fade out the overlay
    function hideOverlay() {
        searchOverlay.classList.remove('visible');
    }

    // Open overlay when clicking the search icon
    searchIcon.addEventListener('click', () => {
        showOverlay();
    });

    // Close overlay on clicking the close button
    closeOverlay.addEventListener('click', () => {
        hideOverlay();
    });

    // Close overlay if clicked outside the form
    searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) {
            hideOverlay();
        }
    });
});